<template>
    <div>
        <button 
            @click="loadBladeContent(4)" 
            :disabled="loading"
            class="bg-blue-500 px-4 py-2 rounded"
        >
            {{ loading ? 'Cargando...' : 'Mostrar Trámite' }}
        </button>
        <div v-if="htmlContent" v-html="htmlContent" class="mt-4"></div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import axios from 'axios';

const route = useRoute();
const htmlContent = ref('');
const loading = ref(false);

const loadBladeContent = async (id) => {
    loading.value = true;
    try {
        const { data } = await axios.get(`/tramite/informe/${id}`);
        htmlContent.value = data;
    } catch (error) {
        console.error('Error al cargar el contenido:', error);
    } finally {
        loading.value = false;
    }
};

// Cargar automáticamente al montar el componente (opcional)
onMounted(() => {
    if (route.params.id) { // Si el ID está en la URL (ej: /tramites/4)
        loadBladeContent(route.params.id);
    }
});
</script>

<style scoped>
  .card-header {
    background-color: #FFF8F0;
  }
  
  .table th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
  }
  
  .btn-round {
    border-radius: 50px;
  }
  
  .badge {
    font-size: 0.85em;
    padding: 0.2em 0.4em;
  }
  
  .alert {
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
  }
  
  .alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
  }
  
  .alert-warning {
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
  }
  
  .alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }
</style>